/**
 * @file Generated by js-routes 2.4.1. Based on Rails 8.1.4 routes of Toby::Application.
 * @version 6b2e8ebffe6822bb75d8ceea0b40c72bd7f2ad3ef5a2f147876e69100d475e8c
 * @see https://github.com/railsware/js-routes
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Router = (() => {
    let NodeTypes;
    (function (NodeTypes) {
        NodeTypes[NodeTypes["GROUP"] = 1] = "GROUP";
        NodeTypes[NodeTypes["CAT"] = 2] = "CAT";
        NodeTypes[NodeTypes["SYMBOL"] = 3] = "SYMBOL";
        NodeTypes[NodeTypes["OR"] = 4] = "OR";
        NodeTypes[NodeTypes["STAR"] = 5] = "STAR";
        NodeTypes[NodeTypes["LITERAL"] = 6] = "LITERAL";
        NodeTypes[NodeTypes["SLASH"] = 7] = "SLASH";
        NodeTypes[NodeTypes["DOT"] = 8] = "DOT";
    })(NodeTypes || (NodeTypes = {}));
    const isBrowser = typeof window !== "undefined";
    const UnescapedSpecials = "-._~!$&'()*+,;=:@"
        .split("")
        .map((s) => s.charCodeAt(0));
    const UnescapedRanges = [
        ["a", "z"],
        ["A", "Z"],
        ["0", "9"],
    ].map((range) => range.map((s) => s.charCodeAt(0)));
    class ParametersMissing extends Error {
        constructor(...keys) {
            super(`Route missing required keys: ${keys.join(", ")}`);
            this.keys = keys;
            Object.setPrototypeOf(this, Object.getPrototypeOf(this));
            this.name = ParametersMissing.name;
        }
    }
    const ReservedOptions = [
        "anchor",
        "trailing_slash",
        "subdomain",
        "host",
        "port",
        "protocol",
        "script_name",
    ];
    class Router {
        constructor(config = {}) {
            this.configuration = {
                prefix: "",
                default_url_options: {},
                special_options_key: "__options__",
                serializer: this.default_serializer.bind(this),
                deprecated_false_parameter_behavior: false,
                deprecated_nil_query_parameter_behavior: false,
                include_undefined_query_parameters: true,
            };
            this.configure(config);
        }
        configure(new_config) {
            var _a;
            if (new_config.prefix) {
                console.warn("JsRoutes configuration prefix option is deprecated in favor of default_url_options.script_name.");
            }
            (_a = new_config.serializer) !== null && _a !== void 0 ? _a : (new_config.serializer = this.default_serializer.bind(this));
            this.configuration = { ...this.configuration, ...new_config };
            return this.configuration;
        }
        config() {
            return { ...this.configuration };
        }
        serialize(object) {
            return this.configuration.serializer(object);
        }
        __route(parts_table, route_spec, absolute = false) {
            const required_params = [];
            const parts = [];
            const default_options = {};
            for (const [part, { r: required, d: value }] of Object.entries(parts_table)) {
                parts.push(part);
                if (required) {
                    required_params.push(part);
                }
                if (this.is_not_nullable(value)) {
                    default_options[part] = value;
                }
            }
            const result = (...args) => {
                return this.build_route(parts, required_params, default_options, route_spec, absolute, args);
            };
            result.requiredParams = () => required_params;
            result.toString = () => {
                return this.build_path_spec(route_spec);
            };
            return result;
        }
        default_serializer(value, prefix, array_element = false) {
            if (!prefix && !this.is_object(value)) {
                throw new Error("URL parameters should be a javascript hash");
            }
            prefix = prefix || "";
            const result = [];
            if (this.is_array(value)) {
                // Rails serializes an empty array nested inside another array as a nil
                // query value, while an empty object contributes no query parameter.
                if (value.length === 0) {
                    return array_element
                        ? this.default_serializer(null, prefix + "[]")
                        : "";
                }
                for (const element of value) {
                    const subvalue = this.default_serializer(element, prefix + "[]", true);
                    // Skip empty object results so arrays do not produce leading,
                    // trailing, or doubled "&" separators.
                    if (subvalue.length) {
                        result.push(subvalue);
                    }
                }
            }
            else if (this.is_object(value)) {
                for (let key in value) {
                    if (!this.hasProp(value, key))
                        continue;
                    let prop = value[key];
                    if (!this.configuration.include_undefined_query_parameters &&
                        prop === undefined) {
                        continue;
                    }
                    if (prefix) {
                        key = prefix + "[" + key + "]";
                    }
                    const subvalue = this.default_serializer(prop, key);
                    if (subvalue.length) {
                        result.push(subvalue);
                    }
                }
            }
            else {
                const key = encodeURIComponent(prefix);
                result.push(this.is_not_nullable(value) ||
                    this.configuration.deprecated_nil_query_parameter_behavior
                    ? key + "=" + encodeURIComponent("" + (value !== null && value !== void 0 ? value : ""))
                    : key);
            }
            return result.join("&");
        }
        extract_options(number_of_params, args) {
            const last_el = args[args.length - 1];
            if ((args.length > number_of_params && last_el === 0) ||
                (this.is_object(last_el) && !this.looks_like_serialized_model(last_el))) {
                if (this.is_object(last_el)) {
                    delete last_el[this.configuration.special_options_key];
                }
                return {
                    args: args.slice(0, args.length - 1),
                    options: last_el,
                };
            }
            else {
                return { args, options: {} };
            }
        }
        looks_like_serialized_model(object) {
            return (this.is_object(object) &&
                !(this.configuration.special_options_key in object) &&
                ("id" in object || "to_param" in object || "toParam" in object));
        }
        path_identifier(object) {
            const result = this.unwrap_path_identifier(object);
            return this.is_nullable(result) ||
                (this.configuration.deprecated_false_parameter_behavior &&
                    result === false)
                ? ""
                : "" + result;
        }
        unwrap_path_identifier(object) {
            let result = object;
            if (!this.is_object(object)) {
                return object;
            }
            if ("to_param" in object) {
                result = object.to_param;
            }
            else if ("toParam" in object) {
                result = object.toParam;
            }
            else if ("id" in object) {
                result = object.id;
            }
            else {
                result = object;
            }
            return this.is_callable(result) ? result.call(object) : result;
        }
        partition_parameters(parts, required_params, default_options, call_arguments) {
            let { args, options } = this.extract_options(parts.length, call_arguments);
            if (args.length > parts.length) {
                throw new Error("Too many parameters provided for path");
            }
            let use_all_parts = args.length > required_params.length;
            const parts_options = {
                ...this.configuration.default_url_options,
            };
            for (const key in options) {
                const value = options[key];
                if (!this.hasProp(options, key))
                    continue;
                use_all_parts = true;
                if (parts.includes(key)) {
                    parts_options[key] = value;
                }
            }
            options = {
                ...this.configuration.default_url_options,
                ...default_options,
                ...options,
            };
            const keyword_parameters = {};
            let query_parameters = {};
            for (const key in options) {
                if (!this.hasProp(options, key))
                    continue;
                const value = options[key];
                if (key === "params") {
                    if (this.is_object(value)) {
                        query_parameters = {
                            ...query_parameters,
                            ...value,
                        };
                    }
                    else {
                        throw new Error("params value should always be an object");
                    }
                }
                else if (this.is_reserved_option(key)) {
                    keyword_parameters[key] = value;
                }
                else {
                    if (!this.is_nullable(value) &&
                        (value !== default_options[key] || required_params.includes(key))) {
                        query_parameters[key] = value;
                    }
                }
            }
            const route_parts = use_all_parts ? parts : required_params;
            let i = 0;
            for (const part of route_parts) {
                if (i < args.length) {
                    const value = args[i];
                    if (!this.hasProp(parts_options, part)) {
                        query_parameters[part] = value;
                        ++i;
                    }
                }
            }
            return { keyword_parameters, query_parameters };
        }
        build_route(parts, required_params, default_options, route, absolute, args) {
            const { keyword_parameters, query_parameters } = this.partition_parameters(parts, required_params, default_options, args);
            let { trailing_slash, anchor, script_name } = keyword_parameters;
            const missing_params = required_params.filter((param) => !this.hasProp(query_parameters, param) ||
                this.is_nullable(query_parameters[param]));
            if (missing_params.length) {
                throw new ParametersMissing(...missing_params);
            }
            let result = this.get_prefix() + this.visit(route, query_parameters);
            if (trailing_slash) {
                result = result.replace(/(.*?)[/]?$/, "$1/");
            }
            const url_params = this.serialize(query_parameters);
            if (url_params.length) {
                result += "?" + url_params;
            }
            if (anchor) {
                result += "#" + anchor;
            }
            if (script_name) {
                const last_index = script_name.length - 1;
                if (script_name[last_index] == "/" && result[0] == "/") {
                    script_name = script_name.slice(0, last_index);
                }
                result = script_name + result;
            }
            if (absolute) {
                result = this.route_url(keyword_parameters) + result;
            }
            return result;
        }
        visit(route, parameters, optional = false) {
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return this.visit(route[1], parameters, true);
                case NodeTypes.CAT:
                    return this.visit_cat(route, parameters, optional);
                case NodeTypes.SYMBOL:
                    return this.visit_symbol(route, parameters, optional);
                case NodeTypes.STAR:
                    return this.visit_globbing(route[1], parameters, true);
                case NodeTypes.LITERAL:
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        is_not_nullable(object) {
            return !this.is_nullable(object);
        }
        is_nullable(object) {
            return object === undefined || object === null;
        }
        visit_cat(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, left, right], parameters, optional) {
            const left_part = this.visit(left, parameters, optional);
            let right_part = this.visit(right, parameters, optional);
            if (optional &&
                ((this.is_optional_node(left[0]) && !left_part) ||
                    (this.is_optional_node(right[0]) && !right_part))) {
                return "";
            }
            // if left_part ends on '/' and right_part starts on '/'
            if (left_part[left_part.length - 1] === "/" && right_part[0] === "/") {
                // strip slash from right_part
                // to prevent double slash
                right_part = right_part.substring(1);
            }
            return left_part + right_part;
        }
        visit_symbol(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, key], parameters, optional) {
            const value = this.path_identifier(parameters[key]);
            delete parameters[key];
            if (value.length) {
                return this.encode_segment(value);
            }
            if (optional) {
                return "";
            }
            else {
                throw new ParametersMissing(key);
            }
        }
        encode_segment(segment) {
            if (segment.match(/^[a-zA-Z0-9-]$/)) {
                // Performance optimization for 99% of cases
                return segment;
            }
            return (segment.match(/./gu) || [])
                .map((ch) => {
                const code = ch.charCodeAt(0);
                if (UnescapedRanges.find((range) => code >= range[0] && code <= range[1]) ||
                    UnescapedSpecials.includes(code)) {
                    return ch;
                }
                else {
                    return encodeURIComponent(ch);
                }
            })
                .join("");
        }
        is_optional_node(node) {
            return [NodeTypes.STAR, NodeTypes.SYMBOL, NodeTypes.CAT].includes(node);
        }
        build_path_spec(route, wildcard = false) {
            let key;
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return `(${this.build_path_spec(route[1])})`;
                case NodeTypes.CAT:
                    return (this.build_path_spec(route[1]) + this.build_path_spec(route[2]));
                case NodeTypes.STAR:
                    return this.build_path_spec(route[1], true);
                case NodeTypes.SYMBOL:
                    key = route[1];
                    if (wildcard) {
                        return (key.startsWith("*") ? "" : "*") + key;
                    }
                    else {
                        return ":" + key;
                    }
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                case NodeTypes.LITERAL:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        visit_globbing(route, parameters, optional) {
            const key = route[1];
            let value = parameters[key];
            delete parameters[key];
            if (this.is_nullable(value)) {
                return this.visit(route, parameters, optional);
            }
            if (this.is_array(value)) {
                value = value.join("/");
            }
            const result = this.path_identifier(value);
            return encodeURI(result);
        }
        get_prefix() {
            const prefix = this.configuration.prefix;
            return prefix.match("/$")
                ? prefix.substring(0, prefix.length - 1)
                : prefix;
        }
        route_url(route_defaults) {
            const hostname = route_defaults.host || this.current_host();
            if (!hostname) {
                return "";
            }
            const subdomain = route_defaults.subdomain
                ? route_defaults.subdomain + "."
                : "";
            const protocol = route_defaults.protocol || this.current_protocol();
            let port = route_defaults.port ||
                (!route_defaults.host ? this.current_port() : undefined);
            port = port ? ":" + port : "";
            return protocol + "://" + subdomain + hostname + port;
        }
        current_host() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname)) || "";
        }
        current_protocol() {
            var _a, _b;
            return ((isBrowser && ((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.protocol) === null || _b === void 0 ? void 0 : _b.replace(/:$/, ""))) || "http");
        }
        current_port() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.port)) || "";
        }
        is_object(value) {
            return (typeof value === "object" &&
                Object.prototype.toString.call(value) === "[object Object]");
        }
        is_array(object) {
            return object instanceof Array;
        }
        is_callable(object) {
            return typeof object === "function" && !!object.call;
        }
        is_reserved_option(key) {
            return ReservedOptions.includes(key);
        }
        hasProp(value, key) {
            return Object.prototype.hasOwnProperty.call(value, key);
        }
    }
    return Router;
})();
const __jsr = (() => {
    var _a;
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    ;
    const Modules = {
        references: {
            CJS: {
                define(routes) {
                    if (module) {
                        // Some javascript processors (like vite/rolldown)
                        // warn on using module dot exports in an ESM module.
                        // This just obfuscates that assignment a little so
                        // users don't get a warning they can't fix.
                        const _mod = module;
                        _mod.exports = routes;
                    }
                },
                isSupported() {
                    return typeof module === "object";
                },
            },
            AMD: {
                define(routes) {
                    if (define) {
                        define([], function () {
                            return routes;
                        });
                    }
                },
                isSupported() {
                    return typeof define === "function" && !!define.amd;
                },
            },
            UMD: {
                define(routes) {
                    if (Modules.references.AMD.isSupported()) {
                        Modules.references.AMD.define(routes);
                    }
                    else {
                        if (Modules.references.CJS.isSupported()) {
                            try {
                                Modules.references.CJS.define(routes);
                            }
                            catch (error) {
                                if (error.name !== "TypeError")
                                    throw error;
                            }
                        }
                    }
                },
                isSupported() {
                    return (Modules.references.AMD.isSupported() ||
                        Modules.references.CJS.isSupported());
                },
            },
            ESM: {
                define() {
                    // Module can only be defined using ruby code generation
                },
                isSupported() {
                    // Its impossible to check if "export" keyword is supported
                    return true;
                },
            },
            NIL: {
                define() {
                    // Defined using RubyVariables . WRAPPER
                },
                isSupported() {
                    return true;
                },
            },
            DTS: {
                // Acts the same as ESM
                define(routes) {
                    Modules.references.ESM.define(routes);
                },
                isSupported() {
                    return Modules.references.ESM.isSupported();
                },
            },
            PKG: {
                // Acts the same as ESM
                define() {
                    Modules.references.ESM.define(new Router());
                },
                isSupported() {
                    return Modules.references.ESM.isSupported();
                },
            },
        },
        is_module_supported(name) {
            return this.references[name].isSupported();
        },
        ensure_module_supported(name) {
            if (!this.is_module_supported(name)) {
                throw new Error(`${name} is not supported by runtime`);
            }
        },
        define_module(name, module) {
            this.ensure_module_supported(name);
            this.references[name].define(module);
            return module;
        },
    };
    const router = new Router({
        prefix: "",
        default_url_options: {},
        special_options_key: "_options",
        serializer: (_a = null) !== null && _a !== void 0 ? _a : undefined,
        deprecated_false_parameter_behavior: false,
        deprecated_nil_query_parameter_behavior: false,
        include_undefined_query_parameters: true,
    });
    const __route = router.__route.bind(router);
    return Modules.define_module("ESM", {
        __route,
        configure: router.configure.bind(router),
        config: router.config.bind(router),
        serialize: router.serialize.bind(router),
        ...{},
    });
})();
export const configure = __jsr.configure;

export const config = __jsr.config;

export const serialize = __jsr.serialize;

export const __route = __jsr.__route;

/**
 * Generates rails route to
 * (/:locale)/about
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const aboutPath = /*#__PURE__*/ __route({"locale":{"d":"en"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[6,"about"]]]);

/**
 * Generates rails route to
 * /review/:token(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const acceptReviewInvitePath = /*#__PURE__*/ __route({"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"review"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admingo(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admingoPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admingo/brochure(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admingoBrochurePath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"brochure"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admingo/cancellations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admingoCancellationRequestPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"cancellations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admingo/cancellations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admingoCancellationRequestsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"cancellations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admingo/changelog(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admingoChangelogEntriesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"changelog"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admingo/changelog/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admingoChangelogEntryPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"changelog"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admingo/changelog/:changelog_entry_id/media(.:format)
 * @param {any} changelogEntryId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admingoChangelogEntryMediaPath = /*#__PURE__*/ __route({"changelog_entry_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"changelog"],[2,[7,"/"],[2,[3,"changelog_entry_id"],[2,[7,"/"],[2,[6,"media"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admingo/reports/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admingoContentReportPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admingo/reports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admingoContentReportsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"reports"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admingo/customers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admingoCustomersPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"customers"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admingo/demo(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admingoDemoPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"demo"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admingo/demo/audiences/:key/merge(.:format)
 * @param {any} key
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admingoDemoAudienceMergePath = /*#__PURE__*/ __route({"key":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"demo"],[2,[7,"/"],[2,[6,"audiences"],[2,[7,"/"],[2,[3,"key"],[2,[7,"/"],[2,[6,"merge"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admingo/demo/audiences/:key/renders(.:format)
 * @param {any} key
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admingoDemoAudienceRendersPath = /*#__PURE__*/ __route({"key":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"demo"],[2,[7,"/"],[2,[6,"audiences"],[2,[7,"/"],[2,[3,"key"],[2,[7,"/"],[2,[6,"renders"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admingo/demo/audiences(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admingoDemoAudiencesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"demo"],[2,[7,"/"],[2,[6,"audiences"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admingo/demo/:job_id(.:format)
 * @param {any} jobId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admingoDemoJobPath = /*#__PURE__*/ __route({"job_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"demo"],[2,[7,"/"],[2,[3,"job_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admingo/demo/:job_id/rerun(.:format)
 * @param {any} jobId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admingoDemoJobRerunPath = /*#__PURE__*/ __route({"job_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"demo"],[2,[7,"/"],[2,[3,"job_id"],[2,[7,"/"],[2,[6,"rerun"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admingo/demo/:job_id/video(.:format)
 * @param {any} jobId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admingoDemoJobVideoPath = /*#__PURE__*/ __route({"job_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"demo"],[2,[7,"/"],[2,[3,"job_id"],[2,[7,"/"],[2,[6,"video"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admingo/directives(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admingoDirectivesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"directives"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admingo/domains/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admingoDomainPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"domains"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admingo/domains(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admingoDomainsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"domains"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admingo/form-submissions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admingoFormSubmissionsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"form-submissions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admingo/go/pwa(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admingoGoPwaPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"go"],[2,[7,"/"],[2,[6,"pwa"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admingo/handoffs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admingoHandoffsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"handoffs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admingo/how-it-works(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admingoHowItWorksPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"how-it-works"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admingo/knowledgebase(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admingoKnowledgebasePath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"knowledgebase"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admingo/knowledgebase/:slug(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admingoKnowledgebaseDocumentPath = /*#__PURE__*/ __route({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"knowledgebase"],[2,[7,"/"],[2,[3,"slug"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admingo/lifecycle-mails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admingoLifecycleMailsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"lifecycle-mails"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admingo/mail/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admingoMailDomainPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"mail"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admingo/mail/:mail_domain_id/addresses/:id(.:format)
 * @param {any} mailDomainId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admingoMailDomainAddressPath = /*#__PURE__*/ __route({"mail_domain_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"mail"],[2,[7,"/"],[2,[3,"mail_domain_id"],[2,[7,"/"],[2,[6,"addresses"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admingo/mail/:mail_domain_id/addresses(.:format)
 * @param {any} mailDomainId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admingoMailDomainAddressesPath = /*#__PURE__*/ __route({"mail_domain_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"mail"],[2,[7,"/"],[2,[3,"mail_domain_id"],[2,[7,"/"],[2,[6,"addresses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admingo/mail(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admingoMailDomainsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"mail"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admingo/new-businesses/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admingoNewBusinessRunPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"new-businesses"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admingo/new-businesses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admingoNewBusinessRunsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"new-businesses"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admingo/partner-requests/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admingoPartnerRequestPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"partner-requests"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admingo/partner-requests(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admingoPartnerRequestsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"partner-requests"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admingo/placards(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admingoPlacardsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"placards"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admingo/plans(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admingoPlansPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"plans"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admingo/prospects/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admingoProspectPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"prospects"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admingo/prospects(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admingoProspectsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"prospects"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admingo/referrals(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admingoReferralsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"referrals"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admingo/registrar(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admingoRegistrarPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"registrar"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admingo/reviewer_invites(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admingoReviewerInvitesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"reviewer_invites"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admingo/rob/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admingoRobPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"rob"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admingo/rob(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admingoRobIndexPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"rob"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admingo/scout(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admingoScoutPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"scout"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admingo/scout/searches/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admingoScoutSearchPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"scout"],[2,[7,"/"],[2,[6,"searches"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admingo/short-links/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admingoShortLinkPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"short-links"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admingo/short-links(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admingoShortLinksPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"short-links"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admingo/sites/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admingoSitePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"sites"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admingo/sites/:site_id/analytics(.:format)
 * @param {any} siteId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admingoSiteAnalyticsPath = /*#__PURE__*/ __route({"site_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"sites"],[2,[7,"/"],[2,[3,"site_id"],[2,[7,"/"],[2,[6,"analytics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admingo/sites/:site_id/form-submissions(.:format)
 * @param {any} siteId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admingoSiteFormSubmissionsPath = /*#__PURE__*/ __route({"site_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"sites"],[2,[7,"/"],[2,[3,"site_id"],[2,[7,"/"],[2,[6,"form-submissions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admingo/sites/:site_id/members/:id(.:format)
 * @param {any} siteId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admingoSiteMemberPath = /*#__PURE__*/ __route({"site_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"sites"],[2,[7,"/"],[2,[3,"site_id"],[2,[7,"/"],[2,[6,"members"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admingo/sites/:site_id/members(.:format)
 * @param {any} siteId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admingoSiteMembersPath = /*#__PURE__*/ __route({"site_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"sites"],[2,[7,"/"],[2,[3,"site_id"],[2,[7,"/"],[2,[6,"members"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admingo/sites/:site_id/photos/:id(.:format)
 * @param {any} siteId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admingoSitePhotoPath = /*#__PURE__*/ __route({"site_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"sites"],[2,[7,"/"],[2,[3,"site_id"],[2,[7,"/"],[2,[6,"photos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admingo/sites/:site_id/photos(.:format)
 * @param {any} siteId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admingoSitePhotosPath = /*#__PURE__*/ __route({"site_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"sites"],[2,[7,"/"],[2,[3,"site_id"],[2,[7,"/"],[2,[6,"photos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admingo/sites/:site_id/preferences(.:format)
 * @param {any} siteId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admingoSitePreferencesPath = /*#__PURE__*/ __route({"site_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"sites"],[2,[7,"/"],[2,[3,"site_id"],[2,[7,"/"],[2,[6,"preferences"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admingo/sites/:site_id/registration(.:format)
 * @param {any} siteId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admingoSiteRegistrationPath = /*#__PURE__*/ __route({"site_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"sites"],[2,[7,"/"],[2,[3,"site_id"],[2,[7,"/"],[2,[6,"registration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admingo/sites/:site_id/subscribers(.:format)
 * @param {any} siteId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admingoSiteSubscribersPath = /*#__PURE__*/ __route({"site_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"sites"],[2,[7,"/"],[2,[3,"site_id"],[2,[7,"/"],[2,[6,"subscribers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admingo/sites/:site_id/takeover(.:format)
 * @param {any} siteId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admingoSiteTakeoverPath = /*#__PURE__*/ __route({"site_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"sites"],[2,[7,"/"],[2,[3,"site_id"],[2,[7,"/"],[2,[6,"takeover"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admingo/sites/:site_id/videos(.:format)
 * @param {any} siteId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admingoSiteVideosPath = /*#__PURE__*/ __route({"site_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"sites"],[2,[7,"/"],[2,[3,"site_id"],[2,[7,"/"],[2,[6,"videos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admingo/sites(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admingoSitesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"sites"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admingo/sites-all(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admingoSitesAllPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"sites-all"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admingo/sites-paid(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admingoSitesPaidPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"sites-paid"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admingo/sites-protected(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admingoSitesProtectedPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"sites-protected"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admingo/users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admingoUserPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admingo/users/:user_id/interval_switch(.:format)
 * @param {any} userId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admingoUserIntervalSwitchPath = /*#__PURE__*/ __route({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"interval_switch"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admingo/users/:user_id/referral_cards(.:format)
 * @param {any} userId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admingoUserReferralCardsPath = /*#__PURE__*/ __route({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"referral_cards"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admingo/users/:user_id/voice_command_mode(.:format)
 * @param {any} userId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admingoUserVoiceCommandModePath = /*#__PURE__*/ __route({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"voice_command_mode"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admingo/users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admingoUsersPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admingo/sites/:site_id/videos/:id/allow(.:format)
 * @param {any} siteId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const allowAdmingoSiteVideoPath = /*#__PURE__*/ __route({"site_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"sites"],[2,[7,"/"],[2,[3,"site_id"],[2,[7,"/"],[2,[6,"videos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"allow"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /no-track-me(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const analyticsOptOutPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"no-track-me"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admingo/scout/analyze(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const analyzeAdmingoScoutPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"scout"],[2,[7,"/"],[2,[6,"analyze"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /auth/apple_id_token(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const appleIdTokenSignInPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"apple_id_token"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admingo/prospects/:id/artifacts/:artifact_id/download(.:format)
 * @param {any} id
 * @param {any} artifactId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const artifactDownloadAdmingoProspectPath = /*#__PURE__*/ __route({"id":{"r":true},"artifact_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"prospects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"artifacts"],[2,[7,"/"],[2,[3,"artifact_id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admingo/registrar/attention(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attentionAdmingoRegistrarPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"registrar"],[2,[7,"/"],[2,[6,"attention"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /billing/checkout(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const billingCheckoutPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"checkout"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /billing/interval_switch(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const billingIntervalSwitchPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"interval_switch"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /billing/invoice_subscription(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const billingInvoiceSubscriptionPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"invoice_subscription"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /billing/plans(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const billingPlansPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"plans"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /billing/portal(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const billingPortalPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"portal"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /billing/signup_checkout(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const billingSignupCheckoutPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"signup_checkout"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /billing/sites/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const billingSitePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"sites"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /billing/site_items(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const billingSiteItemsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"site_items"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /billing/success(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const billingSuccessPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"success"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admingo/prospects/:id/build_site(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buildSiteAdmingoProspectPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"prospects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"build_site"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admingo/prospects/bulk_destroy(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulkDestroyAdmingoProspectsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"prospects"],[2,[7,"/"],[2,[6,"bulk_destroy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admingo/sites/bulk_destroy(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulkDestroyAdmingoSitesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"sites"],[2,[7,"/"],[2,[6,"bulk_destroy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /cancel(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancelPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admingo/handoffs/:id/cancel(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancelAdmingoHandoffPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"handoffs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/cancel
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancelContractPath = /*#__PURE__*/ __route({"locale":{"d":"en"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[6,"cancel"]]]);

/**
 * Generates rails route to
 * /cancellations/undo/:token(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancellationUndoPath = /*#__PURE__*/ __route({"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cancellations"],[2,[7,"/"],[2,[6,"undo"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /chat_mode(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const chatModePath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"chat_mode"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admingo/domains/check(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checkAdmingoDomainsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"domains"],[2,[7,"/"],[2,[6,"check"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /domain_registrations/check(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checkDomainRegistrationsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"domain_registrations"],[2,[7,"/"],[2,[6,"check"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /claim/:public_id(.:format)
 * @param {any} publicId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const claimHandoffPath = /*#__PURE__*/ __route({"public_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"claim"],[2,[7,"/"],[2,[3,"public_id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /placards/:code/claim(.:format)
 * @param {any} code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const claimPlacardPath = /*#__PURE__*/ __route({"code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"placards"],[2,[7,"/"],[2,[3,"code"],[2,[7,"/"],[2,[6,"claim"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /website/:website_id/settings/newsletter/mailings/:id/compose(.:format)
 * @param {any} websiteId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const composeWebsiteSettingsNewsletterMailingPath = /*#__PURE__*/ __route({"website_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"website"],[2,[7,"/"],[2,[3,"website_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"newsletter"],[2,[7,"/"],[2,[6,"mailings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"compose"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cancellations/undo/:token(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirmCancellationUndoPath = /*#__PURE__*/ __route({"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cancellations"],[2,[7,"/"],[2,[6,"undo"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/confirm-email
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirmEmailPath = /*#__PURE__*/ __route({"locale":{"d":"en"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[6,"confirm-email"]]]);

/**
 * Generates rails route to
 * /billing/invoice_subscription/confirmation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirmationBillingInvoiceSubscriptionPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"invoice_subscription"],[2,[7,"/"],[2,[6,"confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/contact
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const contactPath = /*#__PURE__*/ __route({"locale":{"d":"en"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[6,"contact"]]]);

/**
 * Generates rails route to
 * /contact-reports/:token(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const contactReportPath = /*#__PURE__*/ __route({"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"contact-reports"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /contact-reports/:token(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createContactReportPath = /*#__PURE__*/ __route({"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"contact-reports"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admingo/sites/:id/crm(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const crmAdmingoSitePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"sites"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"crm"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admingo/sites/:id/demo_baseline(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const demoBaselineAdmingoSitePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"sites"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"demo_baseline"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/docs
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const docsPath = /*#__PURE__*/ __route({"locale":{"d":"en"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[6,"docs"]]]);

/**
 * Generates rails route to
 * (/:locale)/docs/editing
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const docsEditingPath = /*#__PURE__*/ __route({"locale":{"d":"en"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"docs"],[2,[7,"/"],[6,"editing"]]]]]);

/**
 * Generates rails route to
 * (/:locale)/docs/imports
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const docsImportsPath = /*#__PURE__*/ __route({"locale":{"d":"en"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"docs"],[2,[7,"/"],[6,"imports"]]]]]);

/**
 * Generates rails route to
 * (/:locale)/docs/media
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const docsMediaPath = /*#__PURE__*/ __route({"locale":{"d":"en"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"docs"],[2,[7,"/"],[6,"media"]]]]]);

/**
 * Generates rails route to
 * (/:locale)/docs/newsletter
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const docsNewsletterPath = /*#__PURE__*/ __route({"locale":{"d":"en"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"docs"],[2,[7,"/"],[6,"newsletter"]]]]]);

/**
 * Generates rails route to
 * (/:locale)/docs/prompts
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const docsPromptsPath = /*#__PURE__*/ __route({"locale":{"d":"en"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"docs"],[2,[7,"/"],[6,"prompts"]]]]]);

/**
 * Generates rails route to
 * (/:locale)/docs/publishing
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const docsPublishingPath = /*#__PURE__*/ __route({"locale":{"d":"en"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"docs"],[2,[7,"/"],[6,"publishing"]]]]]);

/**
 * Generates rails route to
 * (/:locale)/docs/voice
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const docsVoicePath = /*#__PURE__*/ __route({"locale":{"d":"en"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"docs"],[2,[7,"/"],[6,"voice"]]]]]);

/**
 * Generates rails route to
 * /domain_registrations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const domainRegistrationsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"domain_registrations"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admingo/changelog/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdmingoChangelogEntryPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"changelog"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /elements(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const elementsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"elements"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /auth/email(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const emailSignInPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"email"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /auth/email/:token(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const emailSignInLinkPath = /*#__PURE__*/ __route({"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"email"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admingo/sites/:site_id/registration/fail(.:format)
 * @param {any} siteId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const failAdmingoSiteRegistrationPath = /*#__PURE__*/ __route({"site_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"sites"],[2,[7,"/"],[2,[3,"site_id"],[2,[7,"/"],[2,[6,"registration"],[2,[7,"/"],[2,[6,"fail"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/features
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const featuresPath = /*#__PURE__*/ __route({"locale":{"d":"en"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[6,"features"]]]);

/**
 * Generates rails route to
 * /website/:website_id/settings/download/file(.:format)
 * @param {any} websiteId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fileWebsiteSettingsDataExportPath = /*#__PURE__*/ __route({"website_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"website"],[2,[7,"/"],[2,[3,"website_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"download"],[2,[7,"/"],[2,[6,"file"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admingo/live_sessions/:id/force_end(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const forceEndAdmingoLiveSessionPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"live_sessions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"force_end"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admingo/prospects/:id/generate_report(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generateReportAdmingoProspectPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"prospects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"generate_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /geo(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const geoPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"geo"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /go(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const goPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"go"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /go/pwa(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const goPwaPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"go"],[2,[7,"/"],[2,[6,"pwa"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /auth/google_id_token(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const googleIdTokenSignInPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"google_id_token"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admingo/scout/guess_languages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guessLanguagesAdmingoScoutPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"scout"],[2,[7,"/"],[2,[6,"guess_languages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admingo/scout/hosting(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hostingAdmingoScoutPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"scout"],[2,[7,"/"],[2,[6,"hosting"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admingo/sites/:id/impersonate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const impersonateAdmingoSitePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"sites"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"impersonate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admingo/domains/infrastructure(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const infrastructureAdmingoDomainsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"domains"],[2,[7,"/"],[2,[6,"infrastructure"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /__internal/contact/notifications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalContactNotificationsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"__internal"],[2,[7,"/"],[2,[6,"contact"],[2,[7,"/"],[2,[6,"notifications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /__internal/e2e/discard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalE2eDiscardPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"__internal"],[2,[7,"/"],[2,[6,"e2e"],[2,[7,"/"],[2,[6,"discard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /__internal/e2e/dossier(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalE2eDossierPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"__internal"],[2,[7,"/"],[2,[6,"e2e"],[2,[7,"/"],[2,[6,"dossier"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /__internal/e2e/expectations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalE2eExpectationsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"__internal"],[2,[7,"/"],[2,[6,"e2e"],[2,[7,"/"],[2,[6,"expectations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /__internal/e2e/judge(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalE2eJudgePath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"__internal"],[2,[7,"/"],[2,[6,"e2e"],[2,[7,"/"],[2,[6,"judge"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /__internal/e2e/seed_home(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalE2eSeedHomePath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"__internal"],[2,[7,"/"],[2,[6,"e2e"],[2,[7,"/"],[2,[6,"seed_home"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /__internal/e2e/seed_site(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalE2eSeedSitePath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"__internal"],[2,[7,"/"],[2,[6,"e2e"],[2,[7,"/"],[2,[6,"seed_site"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /__internal/e2e/session(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalE2eSessionPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"__internal"],[2,[7,"/"],[2,[6,"e2e"],[2,[7,"/"],[2,[6,"session"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /__internal/e2e/state(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalE2eStatePath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"__internal"],[2,[7,"/"],[2,[6,"e2e"],[2,[7,"/"],[2,[6,"state"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /__internal/live/connect(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalLiveConnectPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"__internal"],[2,[7,"/"],[2,[6,"live"],[2,[7,"/"],[2,[6,"connect"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /__internal/live/transcript(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalLiveTranscriptPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"__internal"],[2,[7,"/"],[2,[6,"live"],[2,[7,"/"],[2,[6,"transcript"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /__internal/live/usage(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalLiveUsagePath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"__internal"],[2,[7,"/"],[2,[6,"live"],[2,[7,"/"],[2,[6,"usage"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /__internal/newsletter/confirmations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalNewsletterConfirmationsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"__internal"],[2,[7,"/"],[2,[6,"newsletter"],[2,[7,"/"],[2,[6,"confirmations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /__internal/sites/:site_id/newsletter/:mailing_id/preview
 * @param {any} siteId
 * @param {any} mailingId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalNewsletterPreviewPath = /*#__PURE__*/ __route({"site_id":{"r":true},"mailing_id":{"r":true}}, [2,[7,"/"],[2,[6,"__internal"],[2,[7,"/"],[2,[6,"sites"],[2,[7,"/"],[2,[3,"site_id"],[2,[7,"/"],[2,[6,"newsletter"],[2,[7,"/"],[2,[3,"mailing_id"],[2,[7,"/"],[6,"preview"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /__internal/newsletter/subscribers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalNewsletterSubscribersPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"__internal"],[2,[7,"/"],[2,[6,"newsletter"],[2,[7,"/"],[2,[6,"subscribers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /__internal/newsletter/unsubscribe(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalNewsletterUnsubscribePath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"__internal"],[2,[7,"/"],[2,[6,"newsletter"],[2,[7,"/"],[2,[6,"unsubscribe"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /__internal/sites/:site_id/preview/*path
 * @param {any} siteId
 * @param {any} path
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalPreviewFragmentPath = /*#__PURE__*/ __route({"site_id":{"r":true},"path":{"r":true}}, [2,[7,"/"],[2,[6,"__internal"],[2,[7,"/"],[2,[6,"sites"],[2,[7,"/"],[2,[3,"site_id"],[2,[7,"/"],[2,[6,"preview"],[2,[7,"/"],[5,[3,"path"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /__internal/sites/:site_id/preview/meta
 * @param {any} siteId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalPreviewMetaPath = /*#__PURE__*/ __route({"site_id":{"r":true}}, [2,[7,"/"],[2,[6,"__internal"],[2,[7,"/"],[2,[6,"sites"],[2,[7,"/"],[2,[3,"site_id"],[2,[7,"/"],[2,[6,"preview"],[2,[7,"/"],[6,"meta"]]]]]]]]]]);

/**
 * Generates rails route to
 * /__internal/puma/stats(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalPumaStatsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"__internal"],[2,[7,"/"],[2,[6,"puma"],[2,[7,"/"],[2,[6,"stats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /__internal/smoke/session(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalSmokeSessionPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"__internal"],[2,[7,"/"],[2,[6,"smoke"],[2,[7,"/"],[2,[6,"session"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /kuendigen(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const kuendigenPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"kuendigen"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * (/:locale)/legal
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const legalPath = /*#__PURE__*/ __route({"locale":{"d":"en"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[6,"legal"]]]);

/**
 * Generates rails route to
 * (/:locale)/legal/agb
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const legalAgbPath = /*#__PURE__*/ __route({"locale":{"d":"en"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"legal"],[2,[7,"/"],[6,"agb"]]]]]);

/**
 * Generates rails route to
 * (/:locale)/legal/data-processors
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const legalDataProcessorsPath = /*#__PURE__*/ __route({"locale":{"d":"en"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"legal"],[2,[7,"/"],[6,"data-processors"]]]]]);

/**
 * Generates rails route to
 * (/:locale)/legal/datenschutz
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const legalDatenschutzPath = /*#__PURE__*/ __route({"locale":{"d":"en"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"legal"],[2,[7,"/"],[6,"datenschutz"]]]]]);

/**
 * Generates rails route to
 * (/:locale)/legal/delete-account
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const legalDeleteAccountPath = /*#__PURE__*/ __route({"locale":{"d":"en"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"legal"],[2,[7,"/"],[6,"delete-account"]]]]]);

/**
 * Generates rails route to
 * (/:locale)/legal/imprint
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const legalImprintPath = /*#__PURE__*/ __route({"locale":{"d":"en"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"legal"],[2,[7,"/"],[6,"imprint"]]]]]);

/**
 * Generates rails route to
 * (/:locale)/legal/privacy
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const legalPrivacyPath = /*#__PURE__*/ __route({"locale":{"d":"en"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"legal"],[2,[7,"/"],[6,"privacy"]]]]]);

/**
 * Generates rails route to
 * (/:locale)/legal/terms
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const legalTermsPath = /*#__PURE__*/ __route({"locale":{"d":"en"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"legal"],[2,[7,"/"],[6,"terms"]]]]]);

/**
 * Generates rails route to
 * /admingo/scout/lighthouse(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lighthouseAdmingoScoutPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"scout"],[2,[7,"/"],[2,[6,"lighthouse"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admingo/prospects/:id/link_site(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const linkSiteAdmingoProspectPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"prospects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"link_site"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /live/tokens(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const liveTokenPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"live"],[2,[7,"/"],[2,[6,"tokens"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admingo/rob/:id/load_more(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const loadMoreAdmingoRobPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"rob"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"load_more"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /locale(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const localePath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"locale"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /(:locale)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const localeRootPath = /*#__PURE__*/ __route({"locale":{"d":"en"}}, [2,[7,"/"],[1,[3,"locale"]]]);

/**
 * Generates rails route to
 * /admingo/domains/lookup(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lookupAdmingoDomainsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"domains"],[2,[7,"/"],[2,[6,"lookup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admingo/sites/:id/mail(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mailAdmingoSitePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"sites"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mail"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /marketing_consent_prompt(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const marketingConsentPromptPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"marketing_consent_prompt"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /marketing_consent_reask(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const marketingConsentReaskPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"marketing_consent_reask"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /unsubscribe/:token(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const marketingUnsubscribePath = /*#__PURE__*/ __route({"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"unsubscribe"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /mistake_disclaimer(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mistakeDisclaimerPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"mistake_disclaimer"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /modernize(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const modernizePath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"modernize"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /modernize/resume(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const modernizeResumePath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"modernize"],[2,[7,"/"],[2,[6,"resume"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /modernize/:site_id/retry(.:format)
 * @param {any} siteId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const modernizeRetryPath = /*#__PURE__*/ __route({"site_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"modernize"],[2,[7,"/"],[2,[3,"site_id"],[2,[7,"/"],[2,[6,"retry"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /modernize/:site_id(.:format)
 * @param {any} siteId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const modernizeStatusPath = /*#__PURE__*/ __route({"site_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"modernize"],[2,[7,"/"],[2,[3,"site_id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admingo/changelog/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdmingoChangelogEntryPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"changelog"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /billing/invoice_subscription/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newBillingInvoiceSubscriptionPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"invoice_subscription"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newRailsConductorInboundEmailPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/sources/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newRailsConductorInboundEmailSourcePath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/news
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newsPath = /*#__PURE__*/ __route({"locale":{"d":"en"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[6,"news"]]]);

/**
 * Generates rails route to
 * (/:locale)/news/:id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newsEntryPath = /*#__PURE__*/ __route({"locale":{"d":"en"},"id":{"r":true}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"news"],[2,[7,"/"],[3,"id"]]]]]);

/**
 * Generates rails route to
 * /nudges/settings/:token(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const nudgeSettingsPath = /*#__PURE__*/ __route({"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"nudges"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /nudges/unsubscribe/:token(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const nudgeUnsubscribePath = /*#__PURE__*/ __route({"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"nudges"],[2,[7,"/"],[2,[6,"unsubscribe"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /auth/:provider(.:format)
 * @param {any} provider
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const omniauthAuthorizePath = /*#__PURE__*/ __route({"provider":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[3,"provider"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /auth/:provider/callback(.:format)
 * @param {any} provider
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const omniauthCallbackPath = /*#__PURE__*/ __route({"provider":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[3,"provider"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /auth/link/:token(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const omniauthConfirmLinkPath = /*#__PURE__*/ __route({"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"link"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /auth/failure(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const omniauthFailurePath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"failure"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/partner
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const partnerPath = /*#__PURE__*/ __route({"locale":{"d":"en"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[6,"partner"]]]);

/**
 * Generates rails route to
 * /partner(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const partnerRequestsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"partner"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /placards/:code(.:format)
 * @param {any} code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const placardPath = /*#__PURE__*/ __route({"code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"placards"],[2,[7,"/"],[2,[3,"code"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /play/offer(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const playOfferPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"play"],[2,[7,"/"],[2,[6,"offer"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /play/purchases(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const playPurchasesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"play"],[2,[7,"/"],[2,[6,"purchases"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /__webhook/play(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const playWebhookPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"__webhook"],[2,[7,"/"],[2,[6,"play"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admingo/placards/:code/poster(.:format)
 * @param {any} code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const posterAdmingoPlacardPath = /*#__PURE__*/ __route({"code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"placards"],[2,[7,"/"],[2,[3,"code"],[2,[7,"/"],[2,[6,"poster"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /website/:website_id/settings/newsletter/poster(.:format)
 * @param {any} websiteId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const posterWebsiteSettingsNewsletterPath = /*#__PURE__*/ __route({"website_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"website"],[2,[7,"/"],[2,[3,"website_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"newsletter"],[2,[7,"/"],[2,[6,"poster"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admingo/placards/posters(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const postersAdmingoPlacardsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"placards"],[2,[7,"/"],[2,[6,"posters"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/press
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pressPath = /*#__PURE__*/ __route({"locale":{"d":"en"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[6,"press"]]]);

/**
 * Generates rails route to
 * (/:locale)/pricing
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pricingPath = /*#__PURE__*/ __route({"locale":{"d":"en"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[6,"pricing"]]]);

/**
 * Generates rails route to
 * /admingo/scout/prospect_status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const prospectStatusAdmingoScoutPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"scout"],[2,[7,"/"],[2,[6,"prospect_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /publish(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const publishPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"publish"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admingo/changelog/:id/publish(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const publishAdmingoChangelogEntryPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"changelog"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"publish"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /push_device(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pushDevicePath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"push_device"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/representations/redirect/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signedBlobId
 * @param {any} variationKey
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsBlobRepresentationPath = /*#__PURE__*/ __route({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/representations/proxy/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signedBlobId
 * @param {any} variationKey
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsBlobRepresentationProxyPath = /*#__PURE__*/ __route({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsConductorInboundEmailPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/:inbound_email_id/incinerate(.:format)
 * @param {any} inboundEmailId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsConductorInboundEmailIncineratePath = /*#__PURE__*/ __route({"inbound_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[3,"inbound_email_id"],[2,[7,"/"],[2,[6,"incinerate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/:inbound_email_id/reroute(.:format)
 * @param {any} inboundEmailId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsConductorInboundEmailReroutePath = /*#__PURE__*/ __route({"inbound_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[3,"inbound_email_id"],[2,[7,"/"],[2,[6,"reroute"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/sources(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsConductorInboundEmailSourcesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsConductorInboundEmailsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/direct_uploads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsDirectUploadsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"direct_uploads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_key/*filename(.:format)
 * @param {any} encodedKey
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsDiskServicePath = /*#__PURE__*/ __route({"encoded_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /up(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsHealthCheckPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"up"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mailgun/inbound_emails/mime(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsMailgunInboundEmailsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"mime"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mandrill/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsMandrillInboundEmailsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mandrill/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsMandrillInboundHealthCheckPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/postmark/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsPostmarkInboundEmailsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"postmark"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/relay/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsRelayInboundEmailsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"relay"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/resend/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsResendInboundEmailsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"resend"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/sendgrid/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsSendgridInboundEmailsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"sendgrid"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/redirect/:signed_id/*filename(.:format)
 * @param {any} signedId
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsServiceBlobPath = /*#__PURE__*/ __route({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/proxy/:signed_id/*filename(.:format)
 * @param {any} signedId
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsServiceBlobProxyPath = /*#__PURE__*/ __route({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admingo/prospects/:id/recapture(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const recaptureAdmingoProspectPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"prospects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"recapture"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admingo/sites/:site_id/registration/recheck(.:format)
 * @param {any} siteId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const recheckAdmingoSiteRegistrationPath = /*#__PURE__*/ __route({"site_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"sites"],[2,[7,"/"],[2,[3,"site_id"],[2,[7,"/"],[2,[6,"registration"],[2,[7,"/"],[2,[6,"recheck"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admingo/mail/:id/reconcile(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reconcileAdmingoMailDomainPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"mail"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reconcile"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/r/:code
 * @param {any} code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const referralLandingPath = /*#__PURE__*/ __route({"locale":{"d":"en"},"code":{"r":true}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[3,"code"]]]]]);

/**
 * Generates rails route to
 * /r/:code
 * @param {any} code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const referralShortPath = /*#__PURE__*/ __route({"code":{"r":true}}, [2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[3,"code"]]]]);

/**
 * Generates rails route to
 * /admingo/sites/:site_id/takeover/refresh(.:format)
 * @param {any} siteId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const refreshAdmingoSiteTakeoverPath = /*#__PURE__*/ __route({"site_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"sites"],[2,[7,"/"],[2,[3,"site_id"],[2,[7,"/"],[2,[6,"takeover"],[2,[7,"/"],[2,[6,"refresh"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /website/:website_id/settings/domain_takeover/refresh(.:format)
 * @param {any} websiteId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const refreshWebsiteSettingsDomainTakeoverPath = /*#__PURE__*/ __route({"website_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"website"],[2,[7,"/"],[2,[3,"website_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"domain_takeover"],[2,[7,"/"],[2,[6,"refresh"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /registrant_contact(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const registrantContactPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"registrant_contact"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admingo/referrals/:id/reject(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rejectAdmingoReferralPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"referrals"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reject"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admingo/sites/:site_id/registration/renewal(.:format)
 * @param {any} siteId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const renewalAdmingoSiteRegistrationPath = /*#__PURE__*/ __route({"site_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"sites"],[2,[7,"/"],[2,[3,"site_id"],[2,[7,"/"],[2,[6,"registration"],[2,[7,"/"],[2,[6,"renewal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admingo/registrar/renewals(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const renewalsAdmingoRegistrarPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"registrar"],[2,[7,"/"],[2,[6,"renewals"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admingo/handoffs/:id/reopen(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reopenAdmingoHandoffPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"handoffs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reopen"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/report
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportPath = /*#__PURE__*/ __route({"locale":{"d":"en"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[6,"report"]]]);

/**
 * Generates rails route to
 * /admingo/rob/:id/rerun(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rerunAdmingoRobPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"rob"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"rerun"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admingo/users/:id/reset_fair_use(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resetFairUseAdmingoUserPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reset_fair_use"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admingo/mail/:mail_domain_id/addresses/:id/reset_password(.:format)
 * @param {any} mailDomainId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resetPasswordAdmingoMailDomainAddressPath = /*#__PURE__*/ __route({"mail_domain_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"mail"],[2,[7,"/"],[2,[3,"mail_domain_id"],[2,[7,"/"],[2,[6,"addresses"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reset_password"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /website/:website_id/settings/email/addresses/:id/reset_password(.:format)
 * @param {any} websiteId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resetPasswordWebsiteSettingsEmailAddressPath = /*#__PURE__*/ __route({"website_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"website"],[2,[7,"/"],[2,[3,"website_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"email"],[2,[7,"/"],[2,[6,"addresses"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reset_password"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admingo/sites/:id/reset_subdomain(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resetSubdomainAdmingoSitePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"sites"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reset_subdomain"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admingo/sites/:site_id/registration/resolve(.:format)
 * @param {any} siteId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resolveAdmingoSiteRegistrationPath = /*#__PURE__*/ __route({"site_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"sites"],[2,[7,"/"],[2,[3,"site_id"],[2,[7,"/"],[2,[6,"registration"],[2,[7,"/"],[2,[6,"resolve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admingo/mail/:id/restore(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const restoreAdmingoMailDomainPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"mail"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"restore"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admingo/mail/:mail_domain_id/addresses/:id/restore(.:format)
 * @param {any} mailDomainId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const restoreAdmingoMailDomainAddressPath = /*#__PURE__*/ __route({"mail_domain_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"mail"],[2,[7,"/"],[2,[3,"mail_domain_id"],[2,[7,"/"],[2,[6,"addresses"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"restore"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admingo/sites/:site_id/photos/:id/restore(.:format)
 * @param {any} siteId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const restoreAdmingoSitePhotoPath = /*#__PURE__*/ __route({"site_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"sites"],[2,[7,"/"],[2,[3,"site_id"],[2,[7,"/"],[2,[6,"photos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"restore"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /website/:website_id/settings/email_notifications/resume(.:format)
 * @param {any} websiteId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resumeWebsiteSettingsEmailNotificationsPath = /*#__PURE__*/ __route({"website_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"website"],[2,[7,"/"],[2,[3,"website_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"email_notifications"],[2,[7,"/"],[2,[6,"resume"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admingo/sites/:site_id/registration/retry(.:format)
 * @param {any} siteId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const retryAdmingoSiteRegistrationPath = /*#__PURE__*/ __route({"site_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"sites"],[2,[7,"/"],[2,[3,"site_id"],[2,[7,"/"],[2,[6,"registration"],[2,[7,"/"],[2,[6,"retry"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admingo/referrals/:id/reverse(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reverseAdmingoReferralPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"referrals"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reverse"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /review/:token(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reviewInvitePath = /*#__PURE__*/ __route({"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"review"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admingo/users/:id/review_left(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reviewLeftAdmingoUserPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"review_left"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /robot
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const robotPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[6,"robot"]]);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rootPath = /*#__PURE__*/ __route({}, [7,"/"]);

/**
 * Generates rails route to
 * /admingo/scout/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const searchAdmingoScoutPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"scout"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /website/:website_id/settings/newsletter/mailings/:id/send_test(.:format)
 * @param {any} websiteId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sendTestWebsiteSettingsNewsletterMailingPath = /*#__PURE__*/ __route({"website_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"website"],[2,[7,"/"],[2,[3,"website_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"newsletter"],[2,[7,"/"],[2,[6,"mailings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send_test"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /website/:website_id/settings/newsletter/mailings/:id/send(.:format)
 * @param {any} websiteId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sendWebsiteSettingsNewsletterMailingPath = /*#__PURE__*/ __route({"website_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"website"],[2,[7,"/"],[2,[3,"website_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"newsletter"],[2,[7,"/"],[2,[6,"mailings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /__webhook/ses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sesWebhookPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"__webhook"],[2,[7,"/"],[2,[6,"ses"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /sessions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sessionPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"sessions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /settings/subscription(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsSubscriptionPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"subscription"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admingo/handoffs/:id/share(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const shareAdmingoHandoffPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"handoffs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"share"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /l/:code(.:format)
 * @param {any} code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const shortLinkPath = /*#__PURE__*/ __route({"code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"l"],[2,[7,"/"],[2,[3,"code"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admingo/scout/shortlist(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const shortlistAdmingoScoutPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"scout"],[2,[7,"/"],[2,[6,"shortlist"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admingo/sidekiq
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sidekiqWebPath = /*#__PURE__*/ __route({}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[6,"sidekiq"]]]]);

/**
 * Generates rails route to
 * /sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const signInPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /sites/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const siteEditorPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"sites"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /sites(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sitesPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"sites"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admingo/prospects/:id/start_import(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const startImportAdmingoProspectPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"prospects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"start_import"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admingo/domains/stats(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const statsAdmingoDomainsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"domains"],[2,[7,"/"],[2,[6,"stats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admingo/rob/:id/status(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const statusAdmingoRobPath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"rob"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /__webhook/stripe(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stripeWebhookPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"__webhook"],[2,[7,"/"],[2,[6,"stripe"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admingo/sites/:id/subdomain(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subdomainAdmingoSitePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"sites"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"subdomain"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /support(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const supportPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"support"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /terms(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const termsAcceptancePath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"terms"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admingo/brochure/terms(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const termsAdmingoBrochurePath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"brochure"],[2,[7,"/"],[2,[6,"terms"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admingo/domains/tlds(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tldsAdmingoDomainsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"domains"],[2,[7,"/"],[2,[6,"tlds"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admingo/sites/:id/toggle_demo(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggleDemoAdmingoSitePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"sites"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_demo"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /nudges/settings/:token(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggleNudgeSettingsPath = /*#__PURE__*/ __route({"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"nudges"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admingo/sites/:id/toggle_protection(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggleProtectionAdmingoSitePath = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admingo"],[2,[7,"/"],[2,[6,"sites"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_protection"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_token(.:format)
 * @param {any} encodedToken
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateRailsDiskServicePath = /*#__PURE__*/ __route({"encoded_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /uploads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const uploadsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"uploads"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /uploads/direct_uploads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const uploadsDirectUploadsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"uploads"],[2,[7,"/"],[2,[6,"direct_uploads"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /uploads/videos(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const uploadsVideosPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"uploads"],[2,[7,"/"],[2,[6,"videos"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /user/settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userSettingsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"settings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /user/settings/appearance(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userSettingsAppearancePath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"appearance"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /user/settings/notifications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userSettingsNotificationsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"notifications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /user/settings/privacy(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userSettingsPrivacyPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"privacy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /user/settings/profile(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userSettingsProfilePath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"profile"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /user/settings/referral(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userSettingsReferralPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"referral"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /user/settings/sessions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userSettingsSessionsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"sessions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /user/settings/sounds(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userSettingsSoundsPath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"sounds"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /user/settings/voice(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userSettingsVoicePath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"voice"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /website/:website_id/analytics(.:format)
 * @param {any} websiteId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const websiteAnalyticsPath = /*#__PURE__*/ __route({"website_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"website"],[2,[7,"/"],[2,[3,"website_id"],[2,[7,"/"],[2,[6,"analytics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /website/:website_id/more(.:format)
 * @param {any} websiteId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const websiteMorePath = /*#__PURE__*/ __route({"website_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"website"],[2,[7,"/"],[2,[3,"website_id"],[2,[7,"/"],[2,[6,"more"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /website/:website_id/settings(.:format)
 * @param {any} websiteId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const websiteSettingsPath = /*#__PURE__*/ __route({"website_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"website"],[2,[7,"/"],[2,[3,"website_id"],[2,[7,"/"],[2,[6,"settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /website/:website_id/settings/memory(.:format)
 * @param {any} websiteId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const websiteSettingsAssistantMemoriesPath = /*#__PURE__*/ __route({"website_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"website"],[2,[7,"/"],[2,[3,"website_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"memory"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /website/:website_id/settings/memory/:id(.:format)
 * @param {any} websiteId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const websiteSettingsAssistantMemoryPath = /*#__PURE__*/ __route({"website_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"website"],[2,[7,"/"],[2,[3,"website_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"memory"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /website/:website_id/settings/contact_email(.:format)
 * @param {any} websiteId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const websiteSettingsContactEmailPath = /*#__PURE__*/ __route({"website_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"website"],[2,[7,"/"],[2,[3,"website_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"contact_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /website/:website_id/settings/download(.:format)
 * @param {any} websiteId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const websiteSettingsDataExportPath = /*#__PURE__*/ __route({"website_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"website"],[2,[7,"/"],[2,[3,"website_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /website/:website_id/settings/design(.:format)
 * @param {any} websiteId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const websiteSettingsDesignPath = /*#__PURE__*/ __route({"website_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"website"],[2,[7,"/"],[2,[3,"website_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"design"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /website/:website_id/settings/domain_takeover(.:format)
 * @param {any} websiteId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const websiteSettingsDomainTakeoverPath = /*#__PURE__*/ __route({"website_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"website"],[2,[7,"/"],[2,[3,"website_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"domain_takeover"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /website/:website_id/settings/email(.:format)
 * @param {any} websiteId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const websiteSettingsEmailPath = /*#__PURE__*/ __route({"website_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"website"],[2,[7,"/"],[2,[3,"website_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /website/:website_id/settings/email/addresses/:id(.:format)
 * @param {any} websiteId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const websiteSettingsEmailAddressPath = /*#__PURE__*/ __route({"website_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"website"],[2,[7,"/"],[2,[3,"website_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"email"],[2,[7,"/"],[2,[6,"addresses"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /website/:website_id/settings/email/addresses(.:format)
 * @param {any} websiteId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const websiteSettingsEmailAddressesPath = /*#__PURE__*/ __route({"website_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"website"],[2,[7,"/"],[2,[3,"website_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"email"],[2,[7,"/"],[2,[6,"addresses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /website/:website_id/settings/messages/:id(.:format)
 * @param {any} websiteId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const websiteSettingsFormMessagePath = /*#__PURE__*/ __route({"website_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"website"],[2,[7,"/"],[2,[3,"website_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /website/:website_id/settings/messages(.:format)
 * @param {any} websiteId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const websiteSettingsFormMessagesPath = /*#__PURE__*/ __route({"website_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"website"],[2,[7,"/"],[2,[3,"website_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /website/:website_id/settings/newsletter(.:format)
 * @param {any} websiteId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const websiteSettingsNewsletterPath = /*#__PURE__*/ __route({"website_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"website"],[2,[7,"/"],[2,[3,"website_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"newsletter"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /website/:website_id/settings/newsletter/mailings/:id(.:format)
 * @param {any} websiteId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const websiteSettingsNewsletterMailingPath = /*#__PURE__*/ __route({"website_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"website"],[2,[7,"/"],[2,[3,"website_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"newsletter"],[2,[7,"/"],[2,[6,"mailings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /website/:website_id/settings/newsletter/mailings(.:format)
 * @param {any} websiteId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const websiteSettingsNewsletterMailingsPath = /*#__PURE__*/ __route({"website_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"website"],[2,[7,"/"],[2,[3,"website_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"newsletter"],[2,[7,"/"],[2,[6,"mailings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /website/:website_id/settings/newsletter/subscribers/:id(.:format)
 * @param {any} websiteId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const websiteSettingsNewsletterSubscriberPath = /*#__PURE__*/ __route({"website_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"website"],[2,[7,"/"],[2,[3,"website_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"newsletter"],[2,[7,"/"],[2,[6,"subscribers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /website/:website_id/settings/newsletter/subscribers(.:format)
 * @param {any} websiteId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const websiteSettingsNewsletterSubscribersPath = /*#__PURE__*/ __route({"website_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"website"],[2,[7,"/"],[2,[3,"website_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"newsletter"],[2,[7,"/"],[2,[6,"subscribers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /website/:website_id/settings/password_protection(.:format)
 * @param {any} websiteId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const websiteSettingsPasswordProtectionPath = /*#__PURE__*/ __route({"website_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"website"],[2,[7,"/"],[2,[3,"website_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"password_protection"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /website/:website_id/settings/site_address(.:format)
 * @param {any} websiteId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const websiteSettingsSiteAddressPath = /*#__PURE__*/ __route({"website_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"website"],[2,[7,"/"],[2,[3,"website_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"site_address"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /website/:website_id/settings/library/:id(.:format)
 * @param {any} websiteId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const websiteSettingsUploadPath = /*#__PURE__*/ __route({"website_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"website"],[2,[7,"/"],[2,[3,"website_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"library"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /website/:website_id/settings/library(.:format)
 * @param {any} websiteId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const websiteSettingsUploadsPath = /*#__PURE__*/ __route({"website_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"website"],[2,[7,"/"],[2,[3,"website_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"library"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /website/:website_id/settings/weekly-tips(.:format)
 * @param {any} websiteId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const websiteSettingsWeeklyTipsPath = /*#__PURE__*/ __route({"website_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"website"],[2,[7,"/"],[2,[3,"website_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"weekly-tips"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /welcome(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const welcomePath = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"welcome"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * (/:locale)/whats-new
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const whatsNewPath = /*#__PURE__*/ __route({"locale":{"d":"en"}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[6,"whats-new"]]]);

